module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-7-latka-8-latka.320617d8.png";